import React, { useState } from "react";
import { Button, Input, Select } from "antd";
import { getDataWithEndpoint } from "../../../functions/request";
import {
  formatDateHourToBR,
  updateData,
} from "../../../functions/functionsUtility";
import { DescriptionsLayout } from "../../../layout";
import { FaSave } from "react-icons/fa";

const estados = [{ value: "SP", label: "São Paulo" }];

const cotacoesLabel = [
  { value: "baco", label: "Baço" },
  { value: "bucho", label: "Bucho" },
  { value: "coracao", label: "Coração" },
  { value: "figado", label: "Fígado" },
  { value: "lingua", label: "Língua s/ Garganta" },
  { value: "miolo", label: "Miolo" },
  { value: "mocoto", label: "Mocotó" },
  { value: "pulmao", label: "Pulmão" },
  { value: "rabo", label: "Rabo" },
  { value: "rins", label: "Rins" },
  { value: "testiculos", label: "Testículos" },
];

export default function InterboisMiudos() {
  const [cotacoesData, setCotacoesData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const aux = Object.entries(cotacoesData).map(([key, value], index) => {
    if (key !== "boi_data" && key !== "boi_uf") {
      const cotLabel = cotacoesLabel.find((label) => label.value === key);
      return {
        label: cotLabel ? cotLabel.label : key,
        children: (
          <Input
            className="input-number"
            value={value}
            disabled={isLoading}
            onChange={(event) => {
              const inputValue = event.target.value;
              const formattedValue = inputValue;
              const newData = {
                ...cotacoesData,
                [key]: formattedValue,
              };
              setCotacoesData(newData);
            }}
          />
        ),
        span: 2,
      };
    }
  });

  const items = [
    {
      label: "Estado",
      children: (
        <Select
          showSearch
          style={{ width: "100%" }}
          optionFilterProp="children"
          placeholder="Selecione um estado"
          filterOption={(input, option) =>
            (option?.label ?? "").includes(input)
          }
          filterSort={(optionA, optionB) =>
            (optionA?.label ?? "")
              .toLowerCase()
              .localeCompare((optionB?.label ?? "").toLowerCase())
          }
          options={estados}
          loading={isLoading}
          onChange={(value) => {
            setIsLoading(true);
            setCotacoesData([]);
            getDataWithEndpoint(
              "boi_miudos",
              `getBoiMiudosbyuf?uf=${encodeURIComponent(value)}`
            )
              .then((res) => {
                setCotacoesData(res);
              })
              .finally(() => {
                setIsLoading(false);
              });
          }}
          allowClear={true}
        />
      ),
      span: 3,
    },
    {
      label: "Última Alteração",
      children: formatDateHourToBR(cotacoesData.boi_data),
      span: 3,
    },
  ];

  return (
    <>
      <DescriptionsLayout
        title={"Interbois - Miúdos"}
        items={[...items, ...aux.filter(Boolean)]}
        extra={
          <div style={{ padding: 10, display: "flex", gap: 10 }}>
            <Button
              type="primary"
              size="large"
              htmlType="submit"
              icon={<FaSave />}
              disabled={isLoading}
              onClick={async () => {
                updateData({
                  ...cotacoesData,
                  endpoint: "updateBoiMiudos",
                  path: "boi_miudos",
                });
              }}
            >
              Atualizar
            </Button>
          </div>
        }
      />
    </>
  );
}
